import React from "react";
import { Navigate } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

export const AdminRoute: React.FC<Props> = ({ children }) => {
  const userData = localStorage.getItem("userData");

  const isAdmin = React.useMemo(() => {
    if (userData) {
      try {
        return JSON.parse(userData)?.admin === true;
      } catch {
        return false;
      }
    }
    return false;
  }, [userData]);

  return isAdmin ? <>{children}</> : <Navigate to="/" replace />;
};
